import React, { forwardRef } from 'react';
import ReactPlayer from 'react-player';

const VideoPlayer = forwardRef(
  ({ videoUrl, playing, setPlaying, isMobile, ...props }, ref) => {
    return (
      <ReactPlayer
        className={isMobile ? 'react-player-mobile' : 'react-player'}
        width="100%"
        height="100%"
        url={videoUrl}
        ref={ref}
        playing={playing}
        muted={false}
        onPlay={() => {
          setPlaying(true);
        }}
        onPause={() => {
          setPlaying(false);
        }}
        onEnded={() => {
          setPlaying(false);
        }}
        onError={(e) => console.warn(e)}
        {...props}
      />
    );
  }
);

export default VideoPlayer;
